
const initialState = {
    requestState : {},
}

function fieldInsFunc(state = initialState , action) {
switch (action.type) {
        case 'STATEREQUEST':
            return {
                requestState : action.state,
          }

        default:
            return state;
    }
}


export default fieldInsFunc;
